import { render, staticRenderFns } from "./PatientEstimate.vue?vue&type=template&id=a221f988&scoped=true"
import script from "./PatientEstimate.vue?vue&type=script&lang=js"
export * from "./PatientEstimate.vue?vue&type=script&lang=js"
import style0 from "./PatientEstimate.vue?vue&type=style&index=0&id=a221f988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a221f988",
  null
  
)

export default component.exports